import { RouteConfig } from "@abaco/web-common/src/app";

const MODULE_BASE_PATH = "/ppm-widget-module";

const routes: RouteConfig[] = [
    {
        name: "pest-dashboard-home",
        path: `pest-dashboard-home`,
        component: () => import("./components/tiles/dashboard/DashboardContainer.vue"),
        meta: {
            navbarItems: ["campaign-select-nav-bar-item", "farm-select-nav-bar-item"]
        }
    }
];

export default routes;
